import pick from 'lodash/pick';
import isBoolean from 'lodash/isBoolean';

import api from '../../store/config/api';
import { FIELDS_LIST as SCHEMA } from '../../schemas'; // eslint-disable-line import/named

import { format } from '../../util/url';

export const [
  GET_PROCESS_FIELDS,
  GET_PROCESS_FIELDS_REQUEST,
  GET_PROCESS_FIELDS_SUCCESS,
  GET_PROCESS_FIELDS_FAILURE
] = api.buildTypes('GET_PROCESS_FIELDS');

export function getProcessFields({ teamName, processID }) {
  const pathname = `/teams/${teamName}/processes/${processID}/fields`;
  const query = { eval: true };
  return {
    type: GET_PROCESS_FIELDS,
    payload: {
      processID,
      url: format({ pathname, query }),
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  GET_VISIBLE_FIELDS,
  GET_VISIBLE_FIELDS_REQUEST,
  GET_VISIBLE_FIELDS_SUCCESS,
  GET_VISIBLE_FIELDS_FAILURE
] = api.buildTypes('GET_VISIBLE_FIELDS');

export const GET_VISIBLE_FIELDS_DEBOUNCE_AMOUNT = 540; // ms

export function getVisibleFields({
  fields = [],
  owner,
  processID,
  runID,
  teamName,
  includeIgnored
}) {
  const query = {};
  const pathname = runID
    ? `/teams/${teamName}/runs/${runID}/visibility` // `runID` must be used over `processID` if both are supplied
    : `/teams/${teamName}/processes/${processID}/visibility`;

  if (isBoolean(includeIgnored)) {
    query.includeIgnored = includeIgnored;
  }

  const url = format({ pathname, query });

  const body = {
    fields: fields
      .map(f => {
        if (f.type !== 'file') {
          return f;
        }
        // this is to ensure we don't actually overwrite the file field
        // used for form submission
        const fileFieldForVisibility = Object.assign({}, f, {
          value:
            f.value && Array.isArray(f.value)
              ? f.value.map(v => v.basename)
              : f.value
        });
        return fileFieldForVisibility;
      })
      .map(f => pick(f, ['fieldName', 'fieldID', 'value']))
  };

  if (owner) {
    body.owner = owner;
  }

  return {
    type: GET_VISIBLE_FIELDS,
    payload: {
      runID,
      processID,
      url,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body,
        retry: true
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/fields.js